// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import store from './store'
import 'vant/lib/index.css'
//引入全局自定义样式
import '../static/css/my.css'
// element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// vant2
import { Swipe, SwipeItem } from 'vant'
import VueClipBoard from 'vue-clipboard2'

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(VueClipBoard)
Vue.config.ignoredElements = [...Vue.config.ignoredElements, 'wx-open-launch-weapp']
/* eslint-disable no-new */
const context = new Vue({
  el: '#app',
  router,
  store, // 注册 Vuex Store
  components: { App },
  template: '<App/>',
  beforeCreate () {
    //在初始化阶段前
    Vue.prototype.$bus = this //配置全局总线，bus有总线的意思
  }
}).$mount('#app');
export default context



// WEBPACK FOOTER //
// ./src/main.js